import axios from "axios"
import { useContext } from "react"
import { useState } from "react"
import { useEffect } from "react"
import AuthContext from "../../../contexts/AuthContext/AuthContext"
import showNotification from "../../../utils/showNotification"
import { ERROR_HANDLER } from "../../../utils/error-handler"

export default function useAdministrativeDashboard() {
   const { authToken } = useContext(AuthContext)
   const [dashboardInfo, setDashboardInfo] = useState(null)
   const [isLoading, setIsLoading] = useState(false)

   // Get initDate as this month's first day
   const firstDayOfThisMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
   const currentDay = new Date();
   const [dateFilter, setDateFilter] = useState([firstDayOfThisMonth, currentDay]);

   useEffect(() => {
      async function getDashboardInfo() {
         if (!dateFilter[0] || !dateFilter[1]) return
         try {
            setIsLoading(true)
            const formatDate = (date) => date.toISOString().split('T')[0];

            const getURL = `${process.env.REACT_APP_BACKEND_SERVER}admin/administracion/dashboardInfo?initDate=${formatDate(dateFilter[0])}&endDate=${formatDate(dateFilter[1])}`


            const { data } = await axios.get(getURL, {
               headers: {
                  "Content-Type": 'application/json',
                  Authorization: `Bearer ${authToken}`
               }
            })
            setDashboardInfo(data)

         } catch (error) {
            console.error(error)
            showNotification({
               color: "red",
               status: "error",
               title: "Error al cargar información y estadísticas del dashboard.",
               message: `Detalle: ${ERROR_HANDLER[error.request?.status] || ERROR_HANDLER.defaultError}`,
               autoClose: 12000
            });
         } finally {
            setIsLoading(false)
         }
      }
      getDashboardInfo()
   }, [authToken, dateFilter])

   return {
      data: dashboardInfo,
      setDashboardInfo,
      isLoading,
      setIsLoading,
      setDateFilter,
      dateFilter,
   }
}
